// Deep import intentional, as turbopack only honors `.web.*` priority at the
// project→node_modules boundary, not for the package's own internal
// relative imports. Importing through `react-native-mmkv`'s index pulls the
// native variant into the web bundle.
import { createMMKV } from "react-native-mmkv/lib/createMMKV/createMMKV";

import type { StorageOptions, SyncStorage } from "./types";

// MMKV's web shim is localStorage-backed and throws if touched during SSR
// (`window` is undefined). Sync device storage is inherently client-only, so
// on the server we present it as empty rather than crashing the render — the
// real values resolve on the client after hydration.
const isServer = () => typeof window === "undefined";

export const createSyncStorage = (options: StorageOptions): SyncStorage => {
  const mmkv = createMMKV({ id: options.namespace });
  return {
    get: key => (isServer() ? null : (mmkv.getString(key) ?? null)),
    set: (key, value) => {
      if (isServer()) {
        return;
      }
      mmkv.set(key, value);
    },
    remove: key => {
      if (isServer()) {
        return;
      }
      mmkv.remove(key);
    },
  };
};
